import { useFeatureFlag } from '@moda/portal-stanchions';
import React from 'react';
import { NewTrunkshowPage } from './NewTrunkshowPage';
import { TrunkshowPage } from './TrunkshowPage';

export const TrunkshowContainer: React.FC = () => {
  const showNewTrunkshowPage = useFeatureFlag('show-new-trunkshow-page', [
    { default: false },
    { if: true, then: true }
  ]);

  if (showNewTrunkshowPage) return <NewTrunkshowPage />;

  return <TrunkshowPage />;
};
